/* DON'T EDIT THIS FILE: edit original and run build again */ // see https://stackoverflow.com/questions/65787971/ways-to-determine-if-something-is-a-plain-object-in-javascript
export const isPlainObject = (value: unknown): value is object => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (
    (prototype === null ||
      prototype === Object.prototype ||
      Object.getPrototypeOf(prototype) === null) &&
    !(Symbol.toStringTag in value) &&
    !(Symbol.iterator in value)
  );
};
